'use client';

import { useCallback } from 'react';
import { useLocalTranslation } from './useLocalTranslation';
import translations from './useDisplayUserName.translations';

export function useDisplayUserName() {
  const { t } = useLocalTranslation(translations);
  return useCallback(
    (firstName?: string | null, lastName?: string | null): string =>
      [firstName, lastName].filter(Boolean).join(' ') || t('anonymous'),
    [t],
  );
}
